import React from 'react';
import Modal from '../../components/Modal';

// The payment went through, but the order could not be honoured — the seat was
// gone a moment earlier, or the payment itself did not finish. No ticket was
// written, so the buyer is told that and what happened to their money: a block
// that was let go at once, or an amount on its way back.
const PaymentConflictModal = ({ phone, seats, amount, orderRef, wasHeld, reason, onClose }) => {
  const failedToFinish = reason === 'capture-failed';
  const seatLabels = (seats || [])
    .map((seat) => seat?.label || [seat?.zone, seat?.number].filter(Boolean).join(' '))
    .filter(Boolean);

  const body = (
    <div className="flex flex-col justify-center items-center text-center space-y-5 py-8">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30">
        <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
          />
        </svg>
      </div>
      <div>
        <h3 className="text-xl font-bold text-surface-900 mb-2">
          {failedToFinish
            ? 'Ödəniş tamamlanmadı'
            : (seatLabels.length > 1 ? 'Seçdiyiniz yerlər tutulub' : 'Seçdiyiniz yer tutulub')}
        </h3>
        <p className="text-sm text-surface-500 leading-relaxed max-w-sm">
          {failedToFinish ? (
            'Texniki səbəbdən ödənişiniz sona çatmadı və bilet yazılmadı. '
          ) : (
            <>
              Siz ödəniş edərkən bu {seatLabels.length > 1 ? 'yerləri' : 'yeri'} başqa alıcı bir neçə
              saniyə əvvəl almışdı. Bilet yazılmadı və{' '}
            </>
          )}
          {wasHeld ? (
            <>
              <strong className="text-surface-700">məbləğ kartınızdan alınmadı</strong> — yalnız
              bloklanmışdı, blok dərhal buraxıldı və məbləğ kartınızın balansına qayıdacaq.
            </>
          ) : (
            <>
              <strong className="text-surface-700">ödənişiniz tam olaraq geri qaytarılır</strong> — məbləğ
              kartınızın balansına qayıdacaq.
            </>
          )}
        </p>
      </div>

      {(seatLabels.length > 0 || amount || orderRef) && (
        <div className="w-full max-w-sm bg-surface-50 rounded-2xl px-5 py-4 text-sm text-surface-500 space-y-1.5 text-left">
          {seatLabels.length > 0 && (
            <div className="flex justify-between gap-3">
              <span>{seatLabels.length > 1 ? 'Yerlər' : 'Yer'}</span>
              <strong className="text-surface-900 text-right">{seatLabels.join(', ')}</strong>
            </div>
          )}
          {!!amount && (
            <div className="flex justify-between gap-3">
              <span>{wasHeld ? 'Buraxılan məbləğ' : 'Geri qaytarılan məbləğ'}</span>
              <strong className="text-surface-900">{amount} AZN</strong>
            </div>
          )}
          {orderRef && (
            <div className="flex justify-between gap-3">
              <span>Sifariş nömrəsi</span>
              <strong className="text-surface-900">{orderRef}</strong>
            </div>
          )}
        </div>
      )}

      <p className="text-sm text-surface-500 max-w-sm">
        {failedToFinish
          ? 'Zəhmət olmasa bir az sonra yenidən cəhd edin.'
          : 'Boş yerlərdən birini seçib yenidən bilet ala bilərsiniz.'}
      </p>

      {phone && (
        <div className="bg-surface-50 rounded-2xl px-5 py-3 text-sm text-surface-500">
          Dəstək: <strong className="text-surface-900">{phone}</strong>
        </div>
      )}
    </div>
  );

  return (
    <Modal
      title=""
      body={body}
      buttons={
        <button
          onClick={() => onClose(false)}
          type="button"
          className="w-full sm:w-auto inline-flex justify-center rounded-2xl bg-accent-600 px-6 py-3 text-sm font-semibold text-white hover:bg-accent-700 transition"
        >
          {failedToFinish ? 'Bağla' : 'Başqa yer seç'}
        </button>
      }
    />
  );
};

export default PaymentConflictModal;
